import { Box, Typography } from '@mui/material';

type Props = {
  driverLabel: string;
  driverValue: string;
};

export const Driver = ({ driverLabel, driverValue }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 2,
        pb: { xs: '0.75rem', sm: 3 },
        gap: 1,
      }}
      data-testid="driver-component"
    >
      <Typography variant="textSmall" sx={{ color: 'neutral.darker' }}>
        {driverLabel}
      </Typography>
      <Typography variant="textBold">{driverValue}</Typography>
    </Box>
  );
};
